<template>
  <div>
    <b-overlay
      :show="blogpostslistdata.length <= 0"
      opacity="0.9"
      spinner-variant="dark"
      spinner-small
      rounded
    >
      <template v-slot:overlay>
        <div class="text-center">
          <b-icon-circle
            variant="dark"
            font-scale="3"
            animation="throb"
          ></b-icon-circle>
          <h4>Retrieving Blogs... Wait a Sec</h4>
        </div>
      </template>
      <b-container fluid>
        <b-row>
          <b-col class="p-0">
            
            <h3 class="text-center">
              {{ allblogposts.length }} Blogposts have been uploaded so far
            </h3>
            
            <b-form-group class="nested-form-group" label-for="institution">
                <b-input-group class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="search"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input type="search" v-model="searchQuery" @keyup="searchFilter" @focus="searching = true" placeholder="Search question"></b-form-input>
                  <b-icon font-scale="1.5" class="close-button" @click="closeSearch" variant="secondary" icon="x"></b-icon>
                </b-input-group>
                
            </b-form-group>

            <p class="text-center">Click any Post  to edit</p>
            <search-list v-if="searching == true" :searchingfor="searchfor" :filtereddata='searchResult'/>
            <div v-if="!searching">
                <b-row>
                    <b-col class="p-0 m-0" sm="6" v-for="blogpost in usedatas" :key="blogpost.track_id">
                        <blogpostsForList
                            :blogpost="blogpost"
                            nextroute="editblogpost"
                            @refetch="refetchBlogs"
                        />
                    </b-col>
                </b-row>
                <div class="text-center vmore" v-if="endnum < endss">
                  <div class="viewmore" @click="showMore">
                    <b-icon-chevron-down font-scale="2" class="mt-3" animation="cylon-vertical"
                      >View More</b-icon-chevron-down
                    >
                  </div>
                  <p class="p-1 m-1 textboldsf">Show More</p>
                </div>
            </div>
            
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import blogpostsForList from "@/components/admin/blogpostsForList.vue";
import searchList from "@/components/admin/searchList"
import { mapState, mapActions } from "vuex";
import store from "@/store";

export default {
  components: {
    blogpostsForList,
    searchList
  },

  data() {
    return {
        startnum: 0,
        limitnum: this.endss,
        intervalnum: 5,
        endnum: 20,
        pager : 1,
        searching : false,
        searchQuery : "",
        searchResult : [],
        searchfor : 'blogposts',
        stockObj : []
    };
  },
  beforeRouteEnter(to, from, next) {

    store.dispatch("admin/fetchBlogs")
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.setnextid(to.params.trackid).then(() => {
      next();
    });
  },
  created() {

    let curpage = this.$route.query.page;    
    this.endnum = this.endnum * Number(curpage);
    this.pager = curpage

    this.queryBlogs()
    this.fetchBlogs()
  },
  methods: {
    ...mapActions("admin", ["fetchBlogs", "setnextid", "queryBlogs"]),

    showMore() {
      let newend = this.endnum + this.intervalnum;
      this.pager = this.getpager + 1

      this.$router.push({
          name : 'listblogposts',
          query : { page : this.pager } 
      })
      
      if (newend < this.endss) {
        this.endnum = newend;
        
      } else {
        this.endnum = this.endss;
      }

      //alert(this.endnum)
      //alert(this.endss)
    },
    refetchBlogs(){
        this.fetchBlogs()
    },

    searchFilter(){
        this.searching = true
        let query = this.searchQuery
        let re = new RegExp(`${query}`, 'gi')
        let searchResult = this.allblogposts.filter( x => re.test(x.question) == true)
        this.searchResult = searchResult
      
    },
    closeSearch(){
      this.searching = false;
      this.searchQuery = ""
    }
    
  },
  computed: {
    ...mapState({
      name: (state) => state.loginmaster.details.fullname,
      trackid : state => state.loginmaster.details.trackid,
      allblogposts: (state) => state.admin.allblogposts,
      blogpostslistdata : state => state.admin.blogpostslistdata
    }),
    getpager(){
      let pagers = this.$route.query.page

      return Number(pagers);
    },
    usedatas() {
        return this.allblogposts.slice(0, this.endnum);
    },
    endss() {
      let end = this.allblogposts.length;
      return end;
    },
  },
};
</script>

<style scoped>
.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}
.close-button{
    position : relative;
    left: -40px;
    top: 5px;
    cursor: pointer;
    z-index : 9999;
}
</style>
